import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServiceHistoryService } from 'src/app/services/service-history.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MaintenancePlanService } from 'src/app/services/maintenance-plan.service';
import { Operation } from 'src/app/model/operation';
import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { DIMBO_CONSTANT } from 'src/app/utils/constant';
import { NgxSpinnerService } from 'ngx-spinner';
import { Repairer } from 'src/app/model/repairer';
import { CacheService } from 'src/app/services/cache.service';
import * as _moment from 'moment';
import { throwMatDuplicatedDrawerError } from '@angular/material/sidenav';
import { ServiceHistoryEditDialogComponent } from '../service-history-edit-dialog/service-history-edit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { IfStmt } from '@angular/compiler';
@Component({
  selector: 'app-service-history-edit',
  templateUrl: './service-history-edit.component.html',
  styleUrls: ['./service-history-edit.component.scss']
})
export class ServiceHistoryEditComponent implements OnInit {
  typesOfServices: any[] = [];
  additionalInfoDialogBoxRef: any;
  showCurrentService: boolean;
  selectedOption: any[] = [];
  filteredOption: any[] = [];
  singleservice: any;
  services: any[] = [];
  operation: any[] = [];
  singleserviceoperation: Operation[];
  filteredOperation: Operation[];
  repairer: Repairer;
  @Input()
  newtabdata: any;
  issueDetected: boolean;
  servicedate: any;
  mileagevalue: any;
  mileageunit: any;
  antiperforationperiod: number;
  antiperforationcomment: any;
  servicehistorycomment: any;
  serviceusage: any;
  numberOfYears: any;
  selecctedantiperforationperiod: any;
  antiperforationCheck: boolean;
  @Output()
  removeTab: EventEmitter<{ isNewTabAdded: boolean }> = new EventEmitter();

  @Output()
  switchToFirst: EventEmitter<{ isSwitchToFirst: boolean }> = new EventEmitter();
  serviceHistoryEditdilogRef: any;
  canceltranlation: any;
  oktranlation: any;
  submittranlation: any;
  vehicleBrandIsNotOV: boolean;

  constructor(private serviceHistory: ServiceHistoryService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private translationService: TranslateService,
    private maintenancePlanService: MaintenancePlanService,
    private spinner: NgxSpinnerService, private cacheService: CacheService) {
    this.numberOfYears = Array(21).fill(1).map((x, i) => i).slice(1);
  }

  ngOnInit(): void {
    this.getServiceHistory(this.newtabdata.serviceId);
    this.canceltranlation = this.translationService.instant('dimbo.i18n.button.close');
    this.submittranlation = this.translationService.instant('dimbo.i18n.button.submit');
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV') {
      this.vehicleBrandIsNotOV = false;
    }
  }
  getServiceHistory(serviceId: string) {
    this.spinner.show();
    this.serviceHistory.getSingleServiceHistory(serviceId)
      .subscribe(response => {
        this.singleservice = response;
        this.serviceusage = this.singleservice.usage;
        this.singleserviceoperation = this.singleservice.operations;
        // console.log(this.singleserviceoperation);
        this.issueDetected = this.singleservice.antiPerforation.issueDetected;
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID)) {
          this.issueDetected = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID);
        }
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID) == false) {
          this.issueDetected = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID);
        }
        this.antiperforationCheck = this.singleservice.antiPerforation.issueDetected;
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK)) {
          this.antiperforationCheck = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK);
        }
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK) == false) {
          this.antiperforationCheck = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK);
        }
        this.servicedate = this.singleservice.Date;
        this.mileagevalue = this.singleservice.mileage.value;
        this.mileageunit = this.singleservice.mileage.unit;
        this.antiperforationperiod = this.singleservice.antiPerforation.period;
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_PERIOD)) {
          this.antiperforationperiod = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_PERIOD);
        }
        this.selecctedantiperforationperiod = this.numberOfYears[this.antiperforationperiod - 1];
        this.antiperforationcomment = this.singleservice.antiPerforation.comment;
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_COMMENT)) {
          this.antiperforationcomment = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_AP_COMMENT);
        }
        this.servicehistorycomment = this.singleservice.comment;
        if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_COMMENT)) {
          this.servicehistorycomment = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_SHE_COMMENT);
        }
        this.repairer = this.singleservice.repairer;
        this.getMaintenancePlan(this.serviceusage);
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
          this.removeTab.emit({ isNewTabAdded: false });
          this.toastrService.warning(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
        } else if (error && error.status && error.status === 404) {
          this.spinner.hide();
          this.removeTab.emit({ isNewTabAdded: false });
          this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
        }
        else {
          this.spinner.hide();
          this.removeTab.emit({ isNewTabAdded: false });
          this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
        }
      });
  }

  getMaintenancePlan(serviceusage) {
    if (this.showCurrentService) {
      return false;
    }
    this.spinner.show();
    this.typesOfServices.length = 0;

    /* let params: any = {
      language : 'fr',
      country: 'fr',
      mileageUnit: 'km',
      usage: usage,
      brand: 'AP',
      mileage: '12345'
    } */
    let subusage = serviceusage;
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV') {
      //  subusage='NORMAL';
    }
    let vehicleMilleageUnite = 'yr,' + this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT);
    let params: any = {
      language: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
      country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
      unit: vehicleMilleageUnite,
      usage: subusage,
      brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? 'AP' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
      mileage: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
      firstRegistrationDate: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)
    }

    this.maintenancePlanService.getMaintenancePlan(params)
      .subscribe(response => {
        if (response && response.maintenancePlans[0].operations) {

          for (const operation of response.maintenancePlans[0].operations) {
            let elm: any = {};
            elm.id = operation.reference;
            elm.serviceName = operation.operationLabel;
            elm.order = operation.order;
            elm.statusCode = operation.planningStatus.code;
            elm.statusLabel = operation.planningStatus.label;
            elm.stepFrequency = this.getStepFrequency(operation.steps);
            elm.source = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION);
            elm.typeCode = '';

            this.services.push(elm);
          }

          this.typesOfServices = this.services;
          for (let index = 0; index < this.singleserviceoperation.length; index++) {
            for (var i = this.typesOfServices.length - 1; i >= 0; --i) {
              if (this.typesOfServices[i].id == this.singleserviceoperation[index].maintenancePlanReference) {
                this.singleserviceoperation[index].stepFrequency = this.typesOfServices[i].stepFrequency;
                this.typesOfServices.splice(i, 1);
              }
            }

          }
        } else {
          //  console.log('No maintenance operations found!');
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
            timeOut: 10000,
          });
        }

        this.spinner.hide();

      }, error => {
        this.spinner.hide();
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404) && error.error) {
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
            timeOut: 10000,
          });
        } else {
          this.spinner.hide();
          this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'), {
            timeOut: 10000,
          });
        }
      });
  }

  getStepFrequency(steps: any[]): string {
    let stepFrequency = '';
    if (steps.length === 1) {

      if (steps[0].cycle) {
        if (steps[0].init === steps[0].cycle) {
          if (steps[0].unit === 'Yr') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase') + ' ' + steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          } else if (steps[0].unit === 'Km') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase') + ' ' + steps[0].init + ' ' + 'km';
          } else if (steps[0].unit === 'Mi') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase') + ' ' + steps[0].init + ' ' + 'mi';
          } else {

          }
        } else {
          if (steps[0].unit === 'Yr') {
            stepFrequency = steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.then') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[0].cycle + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          } else if (steps[0].unit === 'Km') {
            stepFrequency = steps[0].init + ' km ' + this.translationService.instant('dimbo.i18n.label.fequency.then') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[0].cycle + ' km';
          } else if (steps[0].unit === 'Mi') {
            stepFrequency = steps[0].init + ' ' + 'mi';
            stepFrequency = steps[0].init + ' mi ' + this.translationService.instant('dimbo.i18n.label.fequency.then') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[0].cycle + ' mi';
          } else {

          }
        }
      } else { // when ther's no cyclic value
        if (steps[0].unit === 'Yr') {
          stepFrequency = steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
        } else if (steps[0].unit === 'Km') {
          stepFrequency = steps[0].init + ' ' + 'km';
        } else if (steps[0].unit === 'Mi') {
          stepFrequency = steps[0].init + ' ' + 'mi';
        } else {

        }
      }



    } else if (steps.length === 2) {


      if (steps[0].cycle) {
        // case 1: When initial period &/or mileage is same as that of Cyclical values of period &/or mileage 
        if ((steps[0].init === steps[0].cycle) || (steps[1].init === steps[1].cycle)) {
          if (steps[1].unit === 'Km') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase') + ' ' + steps[1].init + ' ' + 'km / ' + steps[0].cycle + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          } else {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase') + ' ' + steps[1].init + ' ' + 'mi / ' + steps[0].cycle + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          }
        } else {
          // case 2: When initial period &/or mileage is different as that of Cyclical values of period &/or mileage 
          if (steps[1].unit === 'Km') {
            stepFrequency = steps[1].init + ' ' + 'km / ' + steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.then') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[1].cycle + ' km / ' + steps[0].cycle + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          } else {
            stepFrequency = steps[1].init + ' ' + 'mi / ' + steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years') + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.then') + ' ' + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[1].cycle + ' mi / ' + steps[0].cycle + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
          }
        }
      } else { // if there's no cycle value, only init is present
        // case 1: When initial period &/or mileage is same as that of Cyclical values of period &/or mileage 
        //if ((steps[0].init === steps[0].init) || (steps[1].init === steps[1].cycle)) {
        if (steps[1].unit === 'Km') {
          stepFrequency = steps[1].init + ' ' + 'km / ' + steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
        } else {
          stepFrequency = steps[1].init + ' ' + 'mi / ' + steps[0].init + ' ' + this.translationService.instant('dimbo.i18n.label.fequency.years');
        }
        //} 
      }





    } else if (steps.length === 3) {

    } else {

    }
    return stepFrequency;

  }

  onServiceListControlChanged(services) {
    //console.log('selected services: ', services); //selectedOption
    //console.log('typesOfServices  : ', this.typesOfServices);
    this.selectedOption = services.selectedOptions.selected.map(item => item.value);
    //console.log('selected services id: ', this.selectedOption); 
    //console.log('filteredOption before : ', this.filteredOption); 
    this.filteredOption = this.typesOfServices.filter(i => this.selectedOption.includes(i.id));

    /* this.filteredOption = this.typesOfServices.filter(function(item){
      return this.selectedOption.indexOf(item.id) > -1;
    }); */
    // console.log('filteredOption after: ', this.filteredOption); 
  }
  getOperation(filteredOption) {
    let elm: Operation = {
      maintenancePlanReference: filteredOption.id, operationid: null, label: filteredOption.serviceName,
      source: filteredOption.source, stepFrequency: filteredOption.stepFrequency, statusLabel: filteredOption.statusLabel
    };
    return elm;
  }

  onServiceOperationChanged(operation) {
    const servicelocal = this.getService(operation);
    this.typesOfServices.push(servicelocal);

    const index = this.singleserviceoperation.indexOf(operation, 0);
    if (index > -1) {
      this.singleserviceoperation.splice(index, 1);
    }
  }
  getService(operation) {
    let elm: any = {};
    elm.id = operation.maintenancePlanReference;
    elm.serviceName = operation.label;
    elm.statusLabel = operation.statusLabel;
    elm.stepFrequency = operation.stepFrequency;
    elm.source = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION);
    return elm;
  }

  setAntiperforation(event) {
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK, event.checked);
    if (event.checked) {
      this.antiperforationCheck = true;
    } else {
      this.antiperforationCheck = false;
    }
  }

  addServices() {
    if (this.filteredOption.length > 0) {
      for (const operation of this.filteredOption) {
        const operationlocal = this.getOperation(operation);
        this.singleserviceoperation.push(operationlocal);
      }

      for (const operation of this.filteredOption) {
        const index = this.typesOfServices.indexOf(operation, 0);
        if (index > -1) {
          this.typesOfServices.splice(index, 1);
        }
      }
      this.filteredOption.length = 0;
      this.selectedOption.length = 0;
    }
  }

  dateDiffInDays(date1, date2) {
    let dateObj = new Date(date2);
    if (date2 && dateObj) {
      date2 = formatDate(dateObj, DIMBO_CONSTANT.DATE_FROMAT, 'EN-EN');
    }
    return Math.round((date1 - date2) / (1000 * 60 * 60 * 24));
  }

  onSubmit(form: NgForm) {
    // console.log('Your form data : ', form.value);
    if (this.singleserviceoperation.length == 0) {
      this.toastrService.warning('Please select one Operation');
      return;
    }
    // console.log('this.issueDetected : ', this.issueDetected);
    // console.log('this.antiperforationCheck : ', this.antiperforationCheck);
    let antiperforation: any = {
      period: form.value.antiperforationperiod,
      comment: form.value.antiperforationcomment,
      issueDetected: this.issueDetected,
      antiPerforationCheck: this.antiperforationCheck
    }
    if (!this.antiperforationCheck) {
      antiperforation = { antiPerforationCheck: this.antiperforationCheck };
    }
    let params: any = {
      vin: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN),
      serviceHistory: {
        updatedBy: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_USER_ID),
        updatedOn: _moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss") + 'Z',
        operation: this.singleserviceoperation,
        antiperforation: antiperforation,
        comment: form.value.servicehistorycomment,
        repairer: this.repairer
      }
    };
    // console.log('Your params data : ', params);

    this.serviceHistory.putServiceHistory(this.newtabdata.serviceId, params)
      .subscribe(response => {
        //  console.log('PUT Responce '+response);
        this.toastrService.success(this.translationService.instant('dimbo.i18n.message.record.success'));
        this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_COMMENT);
        this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_COMMENT);
        this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK);
        this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_PERIOD);
        this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID);
        this.removeTab.emit({ isNewTabAdded: false });
        this.switchToFirst.emit({ isSwitchToFirst: true });
      }, error => {
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
          this.toastrService.warning(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
        } else {
          this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
        }
      });
  }

  closedit() {
    this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_COMMENT);
    this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_COMMENT);
    this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_CHECK);
    this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_PERIOD);
    this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID);
    this.removeTab.emit({ isNewTabAdded: false });
    this.switchToFirst.emit({ isSwitchToFirst: true });
  }

  onmileageEdit() {
    // console.log('open additional popup');
    this.openDialogBox('POPUP_VIEW', this.singleservice);
  }

  openDialogBox(eventName: string, singleservice?: any) {
    //  console.log('here...');
    const popupData = { eventName: eventName, singleservice: singleservice };
    this.serviceHistoryEditdilogRef = this.matDialog.open(ServiceHistoryEditDialogComponent, {
      disableClose: true,
      minWidth: '350px',
      minHeight: '350px',
      data: popupData
      // backdropClass: 'custom-dialog'
    });

    this.serviceHistoryEditdilogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.event.eventName === 'POPUP_OK') {
          if (result.event.mileageUpdate) {
            this.toastrService.success(this.translationService.instant('dimbo.i18n.message.mileageUpdate'));
            this.ngOnInit();
          }
        }
        else {

          this.ngOnInit();
        }
      }

    });
  }
  changeservicehistorycomment($event) {
    // console.log('changeservicehistorycomment ', $event.target.value);
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SHE_COMMENT, $event.target.value);
  }
  changeantiperforationcomment($event) {
    //  console.log('changeantiperforationcomment ', $event.target.value);
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SHE_AP_COMMENT, $event.target.value);
  }

  changeissueDetected($event) {
    //  console.log('changeissueDetected ', $event.checked);
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SHE_AP_ID, $event.checked);
    this.antiperforationcomment = '';
  }
  onChangeAntiperforationperiod(value) {
    // console.log('onChangeAntiperforationperiod ', value);
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SHE_AP_PERIOD, value);
  }
}
